// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("./utils.res.js");

function TextInput(props) {
  var __error = props.error;
  var errorText = props.errorText;
  var errorCSS = props.errorCSS;
  var handleChange = props.handleChange;
  var error = __error !== undefined ? __error : false;
  var handleValidation = function ($$event) {
    var name_input = Utils$ReactHooksTemplate.formTargetValue($$event);
    var firstChar = name_input[0];
    var check = Belt_Array.getBy([
          "<",
          "!",
          "=",
          "+",
          "-",
          "@",
          ">",
          "?",
          "'",
          "\"",
          "$",
          "#",
          "%",
          "^",
          "*",
          "(",
          ")",
          "/",
          ".",
          "&",
          ",",
          ";",
          "`",
          "~"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined) {
      console.log("Invalid Characters!");
      return ;
    } else {
      return Curry._1(handleChange, $$event);
    }
  };
  return JsxRuntime.jsxs("label", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: "mb-10-px font-semibold"
                    }),
                JsxRuntime.jsx("input", {
                      className: "border border-gray-500 hover:border-gray-700 focus:border-teal-500 outline-none w-400-px py-10-px px-20-px",
                      type: "text",
                      value: props.value,
                      onChange: handleValidation
                    }),
                error ? JsxRuntime.jsx("div", {
                        children: errorText !== undefined ? errorText : "Error",
                        className: errorCSS !== undefined ? errorCSS : "text-red-600 font-medium"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "block mb-10-px"
            });
}

var make = TextInput;

exports.make = make;
/* react/jsx-runtime Not a pure module */
